import { useLocation } from '@tanstack/react-router';
import { Spin, theme as themeOriginal } from 'antd';
import { useEffect } from 'react';
import { PuffLoader } from 'react-spinners';

export function useBodyClass() {
    const { token } = themeOriginal.useToken();
    const location = useLocation();

    useEffect(() => {
        const body = document.body;
        const isPublicPath = location.pathname.includes('/public');

        if (isPublicPath) {
            // Remove "dt" - default theme class if path includes /public
            body.classList.remove('dt');
            Spin.setDefaultIndicator(<PuffLoader color={'#666'} />);
        } else {
            Spin.setDefaultIndicator(<PuffLoader color={token.colorPrimary} />);
            // Add "dt" class if path doesn't include /public
            body.classList.add('dt');
        }

        // Cleanup function to remove the class when component unmounts
        return () => {
            body.classList.remove('dt');
        };
    }, [location.pathname]);
}
